import api from "services/api";

const authHeaders = () => {
  const token = localStorage.getItem("tk446655440000");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const value = (object, camel, pascal, fallback) =>
  object?.[camel] ?? object?.[pascal] ?? fallback;

export function normalizeManagementResponse(data, pageNumber = 1, pageSize = 25) {
  const items = value(data, "items", "Items", []);
  const pagination = value(data, "pagination", "Pagination", {});
  const summary = value(data, "summary", "Summary", {});

  return {
    items: Array.isArray(items) ? items : [],
    pagination: {
      pageNumber: Number(value(pagination, "pageNumber", "PageNumber", pageNumber)),
      pageSize: Number(value(pagination, "pageSize", "PageSize", pageSize)),
      totalRecords: Number(value(pagination, "totalRecords", "TotalRecords", 0)),
    },
    summary: {
      total: Number(value(summary, "total", "Total", 0)),
      active: Number(value(summary, "active", "Active", 0)),
      inactive: Number(value(summary, "inactive", "Inactive", 0)),
    },
  };
}

export async function getManagedUsers({ status = "all", pageNumber = 1, pageSize = 25, search = "" }) {
  const { data } = await api.get("/Users/management", {
    headers: authHeaders(),
    params: { status, pageNumber, pageSize, search },
  });
  return normalizeManagementResponse(data, pageNumber, pageSize);
}

export async function setManagedUserStatus(userId, isActive, reason = "") {
  const { data } = await api.patch(`/Users/${userId}/status`, { isActive, reason }, {
    headers: authHeaders(),
  });
  return data;
}

export async function getManagedRecruiters({ status = "all", pageNumber = 1, pageSize = 25, search = "" }) {
  const { data } = await api.get("/Recruiters/management", {
    headers: authHeaders(),
    params: { status, pageNumber, pageSize, search },
  });
  return normalizeManagementResponse(data, pageNumber, pageSize);
}

export async function setManagedRecruiterStatus(recruiterId, isActive, reason = "") {
  const { data } = await api.patch(`/Recruiters/${recruiterId}/status`, { isActive, reason }, {
    headers: authHeaders(),
  });
  return data;
}

export function accountIsActive(row) {
  const status = row?.isActive ?? row?.IsActive;
  // Legacy list endpoints predate account status and only return active records.
  return status == null ? true : Boolean(status);
}

export function accountCapability(row, capability) {
  const pascal = capability.charAt(0).toUpperCase() + capability.slice(1);
  return Boolean(row?.[capability] ?? row?.[pascal]);
}

export function canChangeAccountStatus(row) {
  const capability = accountIsActive(row) ? "canDeactivate" : "canActivate";
  return accountCapability(row, capability);
}

export function apiErrorMessage(error, fallback) {
  const data = error?.response?.data;
  return data?.message ?? data?.Message ?? data?.error ?? data?.title ?? fallback;
}
